import {
    ADD_LEAF_NODES,
    ADD_RELATIONSHIP,
    CLEAR_OBJECTIVES_FOR_NODE,
    CLEAR_SELLING_DAYS_FOR_NODE, CREATE_NODE, DELETE_NODE,
    DELETE_RELATIONSHIP,
    GET_BARCODES_FOR_NODE,
    GET_FEATURE_FLAGS,
    GET_HIERARCHY, GET_NODE,
    GET_OBJECTIVES_FOR_NODE,
    GET_SELLING_DAYS_FOR_NODE,
    GET_USERS_FOR_NODE, SET_HEIRARCHY_EXPANSION,
    SET_OBJECTIVES_FOR_NODE,
    UPDATE_BARCODES_FOR_NODE,
    UPDATE_FEATURE_FLAGS,
    UPDATE_SELLING_DAYS_FOR_NODE,
    UPDATE_USERS_FOR_NODE
} from '../constants/action-types';

// INITIALIZE STATE
const initialState = {
    hierarchy: {},
    currentNode: {},
    currentNodeBarcodes: {},
    currentNodeUsers: {},
    currentNodeSellingWeeks: {},
    currentNodeFeatureFlags: {},
    currentNodeObjectives: [],
    hierarchyExpansion: []
};

// REDUCER
export const HierarchyReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_HIERARCHY: {
            const incomingHierarchy = action.payload;
            const hierarchy = {}

            incomingHierarchy.forEach(node => {
                hierarchy[node.id] = node
            });

            return {
                ...state,
                hierarchy: hierarchy
            }
        }

        case CREATE_NODE: {
            return {
                ...state
            }
        }

        case DELETE_NODE: {
            return {
                ...state
            }
        }

        case ADD_RELATIONSHIP: {
            return {
                ...state
            }
        }

        case DELETE_RELATIONSHIP: {
            return {
                ...state
            }
        }

        case ADD_LEAF_NODES: {
            return {
                ...state
            }
        }

        case GET_BARCODES_FOR_NODE: {
            var incomingNodeBarcodes = action.payload;
            var nodeBarcodes = {}

            if (incomingNodeBarcodes == null || incomingNodeBarcodes == "") {
                incomingNodeBarcodes = []
            }

            incomingNodeBarcodes.forEach(barcode => {
                nodeBarcodes[barcode.NodeId] = barcode
            });

            return {
                ...state,
                currentNodeBarcodes: nodeBarcodes
            }
        }

        case GET_USERS_FOR_NODE: {
            var incomingNodeUsers = action.payload;
            var nodeUsers = {}

            if (incomingNodeUsers == null || incomingNodeUsers == "") {
                incomingNodeUsers = []
            }

            incomingNodeUsers.forEach(user => {
                nodeUsers[user] = user
            });

            return {
                ...state,
                currentNodeUsers: nodeUsers
            }
        }

        case GET_SELLING_DAYS_FOR_NODE: {
            var nodeId = action.payload.nodeId;

            var incomingNodeSellingWeeks = action.payload.sellingWeeks.filter(item => item.nodeId == nodeId);
            var nodeSellingWeeks = {}

            if (incomingNodeSellingWeeks == null || incomingNodeSellingWeeks == "") {
                incomingNodeSellingWeeks = []
            }

            incomingNodeSellingWeeks.forEach(sellingWeeks => {
                nodeSellingWeeks[sellingWeeks.id] = sellingWeeks
            });

            return {
                ...state,
                currentNodeSellingWeeks: nodeSellingWeeks
            }
        }

        case UPDATE_BARCODES_FOR_NODE: {
            return {
                ...state
            }
        }

        case UPDATE_USERS_FOR_NODE: {
            return {
                ...state
            }
        }

        case UPDATE_SELLING_DAYS_FOR_NODE: {
            return {
                ...state
            }
        }

        case CLEAR_SELLING_DAYS_FOR_NODE: {
            return {
                ...state
            }
        }

        case GET_FEATURE_FLAGS: {

            const incomingFeatureFlags = action.payload;
            const featureFlags = {}

            incomingFeatureFlags.forEach(featureFlag => {
                featureFlags[featureFlag.Name] = featureFlag
            });

            return {
                ...state,
                currentNodeFeatureFlags: featureFlags
            }
        }

        case UPDATE_FEATURE_FLAGS: {
            return {
                ...state
            }
        }

        case GET_NODE: {
            const incomingNode = action.payload;

            const nodeData = {
                "id": incomingNode.id,
                "DisplayName": incomingNode.displayName,
                "IsLeaf": incomingNode.isLeaf,
                "Parents": incomingNode.parents,
            }

            return {
                ...state,
                currentNode: nodeData
            }
        }

        case GET_OBJECTIVES_FOR_NODE: {
            var incomingNodeObjectives = action.payload;

            if (incomingNodeObjectives == null) {
                incomingNodeObjectives = []
            }

            return {
                ...state,
                currentNodeObjectives: incomingNodeObjectives
            }
        }

        case SET_OBJECTIVES_FOR_NODE: {
            var incomingNodeObjectives = action.payload.objectives;

            if (incomingNodeObjectives == null) {
                incomingNodeObjectives = []
            }

            return {
                ...state,
                currentNodeObjectives: incomingNodeObjectives
            }
        }

        case CLEAR_OBJECTIVES_FOR_NODE: {
            return {
                ...state,
                currentNodeObjectives: []
            }
        }

        case SET_HEIRARCHY_EXPANSION: {
            const hierarchyExpansion = action.payload


            return {
                ...state,
                hierarchyExpansion: hierarchyExpansion
            }
        }

        default:
            return state;
    }
};